import { dbuiV1LinkNotebookOptions } from '@antimatterhq/asl-api-ts-v1';
import { useQuery } from '@antimatterhq/ui/hooks/queries/useQuery';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useGetNotebookLink = (path?: string) => {
  const { workspace } = useWorkspace();

  return useQuery({
    ...dbuiV1LinkNotebookOptions({
      ...defaultOptions(),
      path: { workspace },
      body: {
        path: path || '',
      },
    }),
    enabled: !!workspace && !!path,
  });
};
